import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For example, to get a count of events for your Hubspot contacts you can filter `}<inlineCode parentName="p">{`events.distinct_id`}</inlineCode>{` by `}<inlineCode parentName="p">{`email FROM hubspot_contacts`}</inlineCode>{` like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sql"
      }}>{`SELECT COUNT() AS event_count, distinct_id
FROM events
WHERE distinct_id IN (SELECT email FROM hubspot_contacts)
GROUP BY distinct_id
ORDER BY event_count DESC
`}</code></pre>
    <p>{`You can also use a `}<inlineCode parentName="p">{`JOIN`}</inlineCode>{` such as `}<inlineCode parentName="p">{`INNER JOIN`}</inlineCode>{` or `}<inlineCode parentName="p">{`LEFT JOIN`}</inlineCode>{` to combine data. For example, to get a count of events for your Stripe customers you can `}<inlineCode parentName="p">{`INNER JOIN`}</inlineCode>{` on `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` and `}<inlineCode parentName="p">{`email`}</inlineCode>{` like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-SQL"
      }}>{`SELECT events.distinct_id, COUNT() AS event_count
FROM events
INNER JOIN prod_stripe_customer ON events.distinct_id = prod_stripe_customer.email
GROUP BY events.distinct_id
ORDER BY event_count DESC
`}</code></pre>
    <p>{`To learn more about joining data, see our guide on `}<a parentName="p" {...{
        "href": "/docs/data-warehouse/join"
      }}>{`joining data`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      